import {GiftCard} from "../cart-service";

export class GiftCardSumFormatValueConverter {
    toView(object: any, shippingCosts: number = 0) {
        if (object.giftCards === undefined) {
            return ''
        }
        return this.getSum(object.giftCards, shippingCosts)
    }

    private getSum(giftCards: GiftCard[], shippingCosts: number): number {
        let sum = 0;
        giftCards.forEach(giftCard => {
            sum += giftCard.count * giftCard.amount
        });
        sum += shippingCosts;
        return sum;
    }
}